module.exports = __webpack_public_path__ + "img/電気回路_2_2_4.eead32b6.png";